<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <v-select
      v-model="inputValue"
      :filter="customFilter"
      :disabled="disabled"
      :id="inputId"
      :options="models"
      :reduce="x => x.name"
      :taggable="taggable"
      :create-option="createOption"
      type="text"
      label="name"
      autocomplete="off"
      transition=""
    >
      <span v-if="!transport.mark" slot="no-options">Необходимо выбрать марку ТС.<br>Если это ошибка, обратитесь в поддержку.</span>
      <span v-if="transport.mark" slot="no-options">Модель не найдена. <br>Можете ввести модель вручную.</span>
      <template #open-indicator="{ attributes }">
        <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg" v-bind="attributes">
          <path stroke="null" id="svg_1" d="m10.838366,0.093268l-4.59,4.58l-4.59,-4.58l-1.41,1.41l6,6l6,-6l-1.41,-1.41z"/>
        </svg>
      </template>
    </v-select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import VSelect from 'vue-select'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TransportModelInput',

  components: {
    Hint,
    VSelect
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  props: {
    taggable: {
      type: Boolean,
      default: false
    },

    inputLabel: {
      default: 'Модель ТС'
    },

    inputName: {
      default: 'model'
    },

    inputHint: {
      default: undefined
    },

    models: {
      type: Array,
      default: () => [],
      required: true
    },

    typeaheadItemKey: {
      default: 'name'
    }
  },

  computed: {
    inputId() {
      return `form-visitor-transport-${this.inputName}-${this.visitorIndex}-${this.transportIndex}`
    }
  },

  methods: {
    customFilter(models, search) {
      return models.filter(models =>
        models.name.toLowerCase().startsWith(search.toLowerCase()) ||
        models.name_rus.toLowerCase().startsWith(search.toLowerCase()))
    },

    createOption(newOption) {
      newOption = { name: newOption, name_rus: newOption }
      this.$emit('option:created', newOption)

      return newOption
    }
  }
}
</script>
